import React from "react";
import CommonInputContainer from "./CommonInputContainer";

function CommonTextareaInput({
  value,
  placeholder,
  onChange,
  label,
  error,
  onFocus,
  onBlur,
  className,
}) {
  return (
    <CommonInputContainer
      label={label}
      error={error && !value}
      className={className}
    >
      <div
        className={`w-full border rounded-lg transition-all duration-200 ease-in-out ${
          error && !value ? "border-red-600" : "border-[#DBDBDB]"
        } px-4 py-1`}
      >
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          onFocus={onFocus}
          onBlur={onBlur}
          rows={4}
          className="w-full bg-transparent resize-none scroll-hide placeholder:text-[#A4B1C1] py-1"
        />
      </div>
    </CommonInputContainer>
  );
}

export default CommonTextareaInput;
